"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./style.css");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 *
 * @param {object} props 组件参数
 * @returns
 */
var Pagination = function Pagination(props) {
  // 参数获取
  var currentPages = props.currentPages,
    groupCounts = props.groupCounts,
    totalCounts = props.totalCounts,
    pageCounts = props.pageCounts,
    setCurrentPageFn = props.setCurrentPageFn;
  //当前页码
  var _useState = (0, _react.useState)(currentPages ? currentPages : 1),
    _useState2 = _slicedToArray(_useState, 2),
    currentPage = _useState2[0],
    setCurrentPage = _useState2[1];
  //页码分组，显示7个页码，其余用省略号显示
  var _useState3 = (0, _react.useState)(groupCounts ? groupCounts : 3),
    _useState4 = _slicedToArray(_useState3, 2),
    groupCount = _useState4[0],
    setGroupCount = _useState4[1];
  //分组开始页码
  var _useState5 = (0, _react.useState)(1),
    _useState6 = _slicedToArray(_useState5, 2),
    startPage = _useState6[0],
    setStartPage = _useState6[1];
  //总页数
  var _useState7 = (0, _react.useState)(0),
    _useState8 = _slicedToArray(_useState7, 2),
    totalPage = _useState8[0],
    setTotalPage = _useState8[1];
  /**
   * 根据总条数计算页码
   * @param {number} count 总条数
   * @param {number} pageSize 每页条数
   * @returns
   */
  var pagerCount = function pagerCount(count, pageSize) {
    if (typeof count == 'number') {
      if (count > 0) {
        try {
          var _pagerCount = count % pageSize == 0 ? count / pageSize : count / pageSize + 1;
          var c = Number(_pagerCount.toFixed(0)); //小数取整
          _pagerCount = c > _pagerCount ? c - 1 : c; //过滤四舍五入
          return _pagerCount;
        } catch (error) {
          return 0;
        }
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  };
  //加载时计算总页码
  (0, _react.useEffect)(function () {
    setTotalPage(pagerCount(totalCounts, pageCounts ? pageCounts : 30));
  }, [totalCounts]);
  // 点击页码
  var pageClick = function pageClick(currentPage) {
    //当 当前页码 大于 分组的页码 时，使 当前页 前面 显示 两个页码
    var startPage = currentPage >= groupCount ? currentPage - 2 : 1;
    setStartPage(startPage);
    setCurrentPage(currentPage);
    //将当前页码返回父组件
    setCurrentPageFn(currentPage);
  };
  //上一页事件
  var prePageHandeler = function prePageHandeler() {
    var cp = currentPage;
    pageClick(--cp);
  };
  //下一页事件
  var nextPageHandeler = function nextPageHandeler() {
    var cp = currentPage;
    pageClick(++cp);
  };
  //页码数据
  var pages = [];
  //检测异步数据，获取后再渲染
  if (totalCounts > 0) {
    // 如果当前面不是第一页 则添加上一页
    if (currentPage !== 1) {
      pages.push( /*#__PURE__*/_react.default.createElement("li", {
        onClick: function onClick() {
          prePageHandeler();
        },
        key: 0
      }, ' ', "\u4E0A\u4E00\u9875"));
    }
    /*总页码小于等于10时，全部显示出来*/
    if (totalPage <= 10) {
      var _loop = function _loop(i) {
        pages.push( /*#__PURE__*/_react.default.createElement("li", {
          key: i,
          onClick: function onClick() {
            pageClick(i);
          },
          className: (0, _classnames.default)({
            activePage: currentPage === i
          })
        }, i));
      };
      for (var i = 1; i <= totalPage; i++) {
        _loop(i);
      }
    } else {
      /*总页码大于10时，部分显示*/
      //第一页
      pages.push( /*#__PURE__*/_react.default.createElement("li", {
        className: (0, _classnames.default)({
          activePage: currentPage === 1
        }),
        key: 1,
        onClick: function onClick() {
          pageClick(1);
        }
      }, "1"));
      //前面省略号(当前页码比分组的页码大2页时显示省略号)
      if (currentPage - groupCount >= 2) {
        pages.push( /*#__PURE__*/_react.default.createElement("li", {
          className: "",
          key: -1
        }, "\xB7\xB7\xB7"));
      }
      //非第一页和最后一页显示
      var _loop2 = function _loop2(_i2) {
        if (_i2 <= totalPage - 1 && _i2 > 1) {
          pages.push( /*#__PURE__*/_react.default.createElement("li", {
            className: (0, _classnames.default)({
              activePage: currentPage === _i2
            }),
            key: _i2,
            onClick: function onClick() {
              pageClick(_i2);
            }
          }, _i2));
        }
      };
      for (var _i2 = currentPage - 2; _i2 < currentPage + 3; _i2++) {
        _loop2(_i2);
      }
      //后面省略号
      if (totalPage - startPage >= groupCount + 1) {
        pages.push( /*#__PURE__*/_react.default.createElement("li", {
          className: "",
          key: -2
        }, "\xB7\xB7\xB7"));
      }
      //最后一页
      pages.push( /*#__PURE__*/_react.default.createElement("li", {
        className: (0, _classnames.default)({
          activePage: currentPage === totalPage
        }),
        key: totalPage,
        onClick: function onClick() {
          pageClick(totalPage);
        }
      }, totalPage));
    }
    //如果当前面不是最后一页 则添加下一页
    if (currentPage !== totalPage) {
      pages.push( /*#__PURE__*/_react.default.createElement("li", {
        onClick: function onClick() {
          nextPageHandeler();
        },
        key: totalPage + 1
      }, "\u4E0B\u4E00\u9875"));
    }
  }
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "g-page"
  }, pages);
};
var _default = Pagination;
exports.default = _default;